export interface AppSettings {
  whatsappNumber: string;
  whatsappMessage?: string;
}

export const DEFAULT_SETTINGS: AppSettings = {
  whatsappNumber: '0500000000',
  whatsappMessage: ''
};